import React from 'react';
import { UseFormMethods, Validate } from 'react-hook-form';
import FormInput from '../FormInput';

export interface IFormInput {
  label: string;
  name: string;
  type?: 'text' | 'email' | 'password';
  validate?: Validate | Record<string, Validate>;
  required?: boolean;
}

export interface IOwnProps {
  submitCaption: string;
  inputs: IFormInput[],
  onSubmit: (data: any) => void;
  formHook: UseFormMethods<Record<string, any>>;
  className?: string;
  children?: React.ReactNode;
}

export default function Form({ submitCaption, inputs, onSubmit, formHook, className, children }: IOwnProps) {
  const { handleSubmit } = formHook;

  return <form className={`login-form mt-4${className ? ' ' + className : ''}`} onSubmit={handleSubmit(onSubmit)} noValidate>
    <div className="row">
      {
        inputs.map(item =>
          <div key={item.name} className="col-lg-12">
            <FormInput {...item} formHook={formHook} />
          </div>
        )
      }
      <div className="col-lg-12 mb-0">
        <button
          type="submit"
          className="btn btn-primary btn-block"
        >
          {
            submitCaption
          }
        </button>
      </div>
      {
        children && <div className="col-lg-12 mb-0 mt-3">
          {
            children
          }
        </div>
      }
    </div>
  </form>;
}